import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { NameDto } from 'api/Common/Types'

import {
  ClientSubscriptionDetailBackOfficeDto,
  ClientSubscriptionDetailBackOfficeDtoKey,
} from '../../../../../api/Trading-Accounts/Types/ClientSubscriptionDetailBackOfficeDto'
import { SubscriptionRequestState } from './SubscriptionRequestState'
import { SubscriptionStatusMessage } from './SubscriptionStatusMessage'
import { subscriptionLevelHasActiveSubscriptionRequest } from './subscriptionUtils'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const mapSubscriptionState = (state: NameDto | undefined): string => {
  if (!state) return ''
  return state?.id === SubscriptionRequestState.Completed ||
    state?.id === SubscriptionRequestState.Cancelled
    ? ''
    : state.name
}
const SINGLE_LEVEL_ID = 3
export const clientDetailsSubscriptionsColumns: GridColumn[] = [
  {
    title: 'Subscription Name',
    field: ClientSubscriptionDetailBackOfficeDtoKey.name,
    show: true,
  },
  {
    title: 'Type',
    field: ClientSubscriptionDetailBackOfficeDtoKey.type,
    show: true,
    className: 'clients-table-columns__content',
  },
  {
    title: 'Description',
    field: ClientSubscriptionDetailBackOfficeDtoKey.description,
    show: true,
    className: 'clients-table-columns__content',
  },
  {
    title: 'Level',
    field: ClientSubscriptionDetailBackOfficeDtoKey.level,
    show: true,
    className: 'clients-table-columns__content',
    cell: (props: GridCellProps): JSX.Element => {
      const subscriptionDetails = props.dataItem as ClientSubscriptionDetailBackOfficeDto
      const { id } = subscriptionDetails.level
      const mappedLevelId = id === SINGLE_LEVEL_ID ? 'N/A' : id
      return <td>{mappedLevelId}</td>
    },
  },
  {
    title: 'Price',
    field: ClientSubscriptionDetailBackOfficeDtoKey.price,
    show: true,
    className: 'clients-table-columns__content',
  },
  {
    title: 'Override',
    field: ClientSubscriptionDetailBackOfficeDtoKey.price,
    show: true,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem.clientSubscriptionOverrideDto) {
        return <td className='columns__content'>No</td>
      }
      return <td className='columns__content'>Yes</td>
    },
    className: 'clients-table-columns__content',
  },
  {
    title: 'Currency',
    field: ClientSubscriptionDetailBackOfficeDtoKey.currency,
    show: true,
    className: 'clients-table-columns__content',
  },
  {
    title: 'Status',
    field: ClientSubscriptionDetailBackOfficeDtoKey.status,
    cell: (props: GridCellProps): JSX.Element => {
      const subscriptionDetail = props.dataItem as ClientSubscriptionDetailBackOfficeDto
      const hasActiveSubscription =
        subscriptionLevelHasActiveSubscriptionRequest(subscriptionDetail)

      return (
        <td className='columns__content'>
          {hasActiveSubscription
            ? 'Active'
            : mapSubscriptionState(subscriptionDetail.subscriptionRequest?.state)}
        </td>
      )
    },
    show: true,
    className: 'clients-table-columns__content',
  },
  {
    title: '',
    cell: (props: GridCellProps): JSX.Element => {
      return <SubscriptionStatusMessage {...props} />
    },
    show: true,
    className: 'clients-table-columns__content',
  },
]
